import { FC } from "react";
import ThankYouContent from "./ThankYouContent.tsx";
import ThankYouScreenWrapper, { ThankYouScreenProps } from "./ThankYouScreenWrapper.tsx";

const ThankYouScreenContainerMultiAsset: FC<ThankYouScreenProps> = (props) => {
  const title = props.context === "Live" ? "Application received" : "Your demo account is ready.";

  return (
    <ThankYouScreenWrapper {...props} title={title}>
      <ThankYouContent embedded={props.embedded} context={props.context} />
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenContainerMultiAsset;
